<app-navbar></app-navbar>

<div class="container">
    <div class="row">

        <div class="col-md-3 col-lg-3" style="margin-bottom: 1rem;">


            <div class="leftNav sticky-top" id="top">

                <ul class="list-group mt-5 shadow" style="max-height: 350px; overflow: auto;">

                    <a class="list-group-item" [class.active]="activeItem === 0" (click)="setActiveItem(0)"
                        routerLink="/"><i class="fa fa-caret-right mr-2"></i> Introduction</a>


                    <a class="list-group-item" [class.active]="activeItem === 1" (click)="setActiveItem(1)"
                        routerLink="/apilist">
                        <i class="fa fa-caret-right  mr-2"></i> API's List</a>

                    <!-- <a class="list-group-item" [class.active]="activeItem === 2" (click)="setActiveItem(2)"
                        routerLink="/new-apilist">
                        <i class="fa fa-caret-right  mr-2"></i> New API's List</a> -->


                    <a class="list-group-item" [class.active]="activeItem === 3" (click)="setActiveItem(3)" 
                         data-bs-toggle="collapse" href="#gettingStarted">
                        <i class="fa fa-caret-right  mr-2"></i> Getting Started <i style="float: right;" class="fa fa-chevron-down" aria-hidden="true"></i></a>

                    <div class="collapse" id="gettingStarted">

                    
                        <a class="list-group-item" [class.active]="activeItem === 4" (click)="setActiveItem(4)"
                        routerLink="/register" style="display: flex;">
                        <i style="margin-left: 1rem;" class="fa fa-caret-right  mr-2 mt-1"></i> Register On Optimus</a>


                        <a class="list-group-item" [class.active]="activeItem === 5" (click)="setActiveItem(5)"
                        routerLink="/accessToken&secretKey" style="display: flex;">
                        <i class="fa fa-caret-right  mr-2 mt-1" style="margin-left: 1rem;"></i> Generate Access token and Secret key</a>


                        <a class="list-group-item" [class.active]="activeItem === 6" (click)="setActiveItem(6)"
                        routerLink="/tokenGeneration" style="display: flex;">
                        <i class="fa fa-caret-right  mr-2 mt-1"  style="margin-left: 1rem;"></i> Generate Bearer Token</a>


                    <a class="list-group-item" [class.active]="activeItem === 7" (click)="setActiveItem(7)"
                        routerLink="/authentication" style="display: flex;">
                        <i class="fa fa-caret-right  mr-2 mt-1"  style="margin-left: 1rem;"></i> Authenticate and Connect to cloud
                        storage</a>


                    <a href="javascript:void()" class="list-group-item" [class.active]="activeItem === 8"
                        (click)="setActiveItem(8)" routerLink="/submitBatch" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> Submit Batch Job specific to that cloud
                        storage</a>



                    <a class="list-group-item" [class.active]="activeItem === 9" (click)="setActiveItem(9)"
                        routerLink="/websocket" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> Get Job Status on WebSocket</a>




                    <a class="list-group-item" [class.active]="activeItem === 10" (click)="setActiveItem(10)"
                        routerLink="/webhook" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> Job Status on Webhook</a>



                    <a class="list-group-item" [class.active]="activeItem === 11" (click)="setActiveItem(11)"
                        routerLink="/jobDetails" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> Get Job Details</a>



                    <a class="list-group-item" [class.active]="activeItem === 12" (click)="setActiveItem(12)"
                        routerLink="/jobSettings" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> Change Job Settings</a>


                    <a class="list-group-item" [class.active]="activeItem === 13" (click)="setActiveItem(13)"
                        routerLink="/live-broadcast" style="display: flex;">
                        <i class="fa fa-caret-right mr-2 mt-1"  style="margin-left: 1rem;"></i> How to do LIVE</a>


                    <!-- <a class="list-group-item" [class.active]="activeItem === 13" (click)="setActiveItem(13)"
                        routerLink="/localFileUpload">
                        <i class="fa fa-caret-right mr-2"></i> Local File Upload and Job Submission</a> -->


                    </div>


                </ul>

            </div>




        </div>

        <div class="col-md-9 col-lg-9" id="routerContent">

            <router-outlet (activate)="onActivate($event)"></router-outlet>

        </div>

    </div>

</div><br><br>


<app-footer></app-footer>